<template>
  <div class="softwareOrderList">
    <el-tabs v-model="activeName" class="orderListTabs" @tab-click="getList">
      <el-tab-pane
        v-for="item in tabList"
        :key="item.id"
        :label="item.name"
        :name="item.id"
      >
      </el-tab-pane>
    </el-tabs>
    <div>
      <div class="orderSearchBox">
          <div class="timeSearch">
              <span style="color: #b2b2b2;">创建时间</span>
              <el-date-picker
                  v-model="createDate"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="—"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
          </div>
          <!-- <div class="timeSearch">
                    <span style="color: #b2b2b2;">区间筛选</span>
                     <el-date-picker
                        v-model="createDateValue"
                        type="daterange"
                         value-format="yyyy-MM-dd"
                        range-separator="—"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        >
                    </el-date-picker>
            </div> -->
        <el-input v-model="softwareName" placeholder="软件名称"></el-input>
          <el-input v-model="orderNo" placeholder="订单编号"></el-input>
        <el-button class="searchBtn" @click="getList">搜索</el-button>
        <el-button type="text" class="resetBtn" @click="reset">
          <i class="iconfont icon-qingchushujuku"></i>
          <span>清除条件</span>
        </el-button>
      </div>
      <div class="orderListTable">
        <ul class="tableHeader">
          <li class="name">软件名称</li>
          <li class="package">套餐版本</li>
          <li class="billing">计费模式</li>
          <li class="price">单价</li>
          <li class="num">数量</li>
          <li class="payment">实付款</li>
          <li class="status">交易状态</li>
          <li class="operation">操作</li>
        </ul>
        <ul class="tableBody" v-if="softwareOrderList.length != 0" v-loading="loading">
          <li
            class="bodyItem"
            v-for="(items, index) in softwareOrderList"
            :key="index"
          >
            <div class="itemTop">
              <div>订单编号：{{ items.orderNo }}</div>
              <div>创建时间：{{ items.createDate }}</div>
            </div>
            <div class="itemBottom">
              <div class="name nameOne">
                  <img :src="items.softwareLogo" alt="" />
                  <div class="infoContent">
                    <div class="infoName">{{ items.softwareName }}</div>
                  </div>
              </div>
              <div class="package">
                {{ items.softwareModelName }}
              </div>
              <div class="billing">
                {{ items.billingModeName }}
              </div>
              <div class="price">
                  ￥{{ items.modelPrice }}
              </div>
              <div class="num">
                  {{ items.buyNum }}
              </div>
              <div class="payment">
                <h3>¥{{ items.actualPayment }}</h3>
              </div>
              <div class="status">
                <div class="statusName">{{ items.stateName }}</div>
                <el-button type="text" class="operationBtn" @click="softwareOrderDetail(items.uuid)">订单详情</el-button>

              </div>
              <div class="operation">
                <el-button
                  type="text"
                  class="operationBtnMoney"
                  @click="toEvaluate(items)"

                  v-if="items.stateName == '待评价' ? true : false"
                  >评价</el-button
                >
                <el-button
                  type="text"
                  class="operationBtnMoney"
                  @click="cancelOrder(items)"
                  v-if="
                    items.stateName == '待确认'
                      ? true
                      : false
                  "
                  >取消订单</el-button
                >
                <el-button
                  type="text"
                  class="operationBtnMoney"
                  @click="makesureSubmit(items.uuid)"
                  v-if="
                    items.stateName == '部署完成'
                      ? true
                      : false
                  "
                  >确认部署完成</el-button
                >
              </div>



              </div>
          </li>
        </ul>
        <!-- <div class="orderNomesaage" v-loading="loading" v-else >暂无数据</div> -->
        <div class="orderNomesaage" v-loading="loading" v-else >
          <img src="../../../assets/暂无订单.jpg" alt="" style="width:200px">
        </div>
      </div>
    </div>
    <el-pagination
      v-if="softwareOrderList.length != 0"
      background
      @current-change="handleCurrentChange"
      @prev-click="handleCurrentChange"
      @next-click="handleCurrentChange"
      layout="total,prev, pager, next,jumper"
      :page-size="pageSize"
      :total="total"
      class="pagination"
    >
    </el-pagination>
      <!--取消订单弹出框-->
      <el-dialog
          title="取消订单"
          :visible.sync="cancelDialogVisible"
          :close-on-click-modal="false"
          width="1000px">
          <div class="logisticsDialog">
              <el-form ref="logisticsForm" :rules="cancelRules" class="demo-ruleForm">
                  <el-form-item class="addressList">
                      <el-select v-model="cancel" placeholder="取消原因">
                          <el-option v-for="(item,index) in cancelList" :key="index"
                                     :label="item.name"
                                     :value="item.uuid+','+item.name">
                          </el-option>
                      </el-select>
                  </el-form-item>
                  <el-form-item class="submitButtonGroup">
                      <el-button type="primary" @click="cancelSubmit">确定</el-button>
                      <el-button @click="cancelDialogVisible = false">取消</el-button>
                  </el-form-item>
              </el-form>
          </div>
      </el-dialog>
      <!--评价弹出框-->
      <el-dialog title="评价" :visible.sync="evaluateDialogVisible" width="500px">
          <div class="evaluateDialogBox">
              <div class="evaluateItem">
                  <div class="name">评价等级</div>
                  <div class="content">
                      <div class="rateItem">
                          <div class="name">描述相符</div>
                          <el-rate
                              v-model="evaluateForm.descriptionPoint"
                              show-score
                              text-color="#ff9900"
                          >
                          </el-rate>
                      </div>
                      <div class="rateItem">
                          <div class="name">服务态度</div>
                          <el-rate
                              v-model="evaluateForm.servicePoint"
                              show-score
                              text-color="#ff9900"
                          >
                          </el-rate>
                      </div>
                      <div class="rateItem">
                          <div class="name">专业程度</div>
                          <el-rate
                              v-model="evaluateForm.transportPoint"
                              show-score
                              text-color="#ff9900"
                          >
                          </el-rate>
                      </div>
                  </div>
              </div>
              <div class="evaluateItem">
                  <div class="name">评价标签</div>
                  <div class="content">
                      <el-checkbox-group
                          v-model="evaluateForm.evaluationTagList"
                          class="evaluateTag"
                      >
                          <el-checkbox-button
                              v-for="tag in tagList"
                              :label="tag"
                              :key="tag.tagUuid"
                          >{{ tag.tagName }}
                          </el-checkbox-button
                          >
                      </el-checkbox-group>
                  </div>
              </div>
              <div class="evaluateItem">
                  <div class="name">评价内容</div>
                  <div class="content">
                      <el-input
                          type="textarea"
                          :autosize="{ minRows: 6 }"
                          placeholder="请输入内容"
                          v-model="evaluateForm.evaluationContent"
                      >
                      </el-input>
                  </div>
              </div>
          </div>
          <span slot="footer" class="dialog-footer">
        <el-button @click="evaluateDialogVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="stepLoading" @click="evaluateSubmit">确 定</el-button>
      </span>
      </el-dialog>
  </div>
</template>

<script>
    import {
        getDictionaryItem,querySoftwareOrderDetailList,getSoftwareOrderDetailByUuid,updateSoftwareOrder,
        saveEvaluation
    } from "../../../utils/interface";
export default {
  name: "softwareOrderList",
  data() {
    return {
        stepLoading: false,
      loading: false,
      activeName: "0",
      tabList: [
        {
          id: "0",
          name: "全部",
        },
        {
          id: "1000",
          name: "待确认",
        },
        {
          id: "1001",
          name: "待部署",
        },
        {
          id: "1002",
          name: "部署完成",
        },
        {
          id: "1003",
          name: "待评价",
        },
        {
          id: "1004",
          name: "订单完成",
        },
      ],
      createDate: null,
      softwareName: "",
      orderNo: "",
      //   分页
      pageNo: 1,
      total: 100,
      pageSize: 5,
      softwareOrderList: [
      ],
        evaluateDialogVisible: false,
        evaluateForm: {
            descriptionPoint: 0,
            servicePoint: 0,
            transportPoint: 0,
            evaluationTagList: [],
            evaluationContent: "",
        },
        tagList: [
        ],
        // 取消
        cancelDialogVisible: false,
        uuid: "",
        cancelList: [],
        cancel: null,
        cancelUuid: "",
        cancelReason: "",
        cancelRules: {
            cancel: [
                {required: true, message: '请选择取消原因', trigger: 'change'}
            ]
        },
    };
  },
    created() {
        this.init();
    },
  methods: {
      // 获取字典值
      getDictionaryItem() {
          getDictionaryItem({groupCode: "software_evaluation_tag"}).then((res) => {
              this.tagList = [];
              res.forEach((item, index) => {
                  this.tagList.push({tagName: item.name, tagUuid: item.code, tagGroupId: item.groupUuid});
              });
          });
      },
      // 取消
      cancelOrder(item){
          getDictionaryItem({groupCode:"software_cancel_reason"}).then((res)=>{
              this.cancelList = res;
              this.uuid = item.uuid;
              this.cancelDialogVisible = true;
          });
      },
      // 取消确定
      cancelSubmit(){
          if(!this.cancel){
              this.$message.error('请选择取消原因！');
              return false;
          }
          let reason = this.cancel.split(",");
          updateSoftwareOrder({uuid:this.uuid,state:"1009",cancelReasonUuid: reason[0], cancelReason:reason[1] }).then((res)=>{
              if(res.success){
                      this.$message.success('订单取消成功！');
                      this.cancelDialogVisible = false;
                      this.getList();
              }
          });
      },
      // 确定部署完成
      makesureSubmit(uuid){
          this.$confirm("是否确认已部署完成", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
          })
              .then(() => {
                  updateSoftwareOrder({uuid:uuid,state:"1003" }).then((res)=>{
                      if(res.success){
                          this.$message.success('操作成功！');
                          this.cancelDialogVisible = false;
                          this.getList();
                      }
                  });
              })
              .catch(() => {
                  this.$message({
                      type: "info",
                      message: "取消确认已部署完成",
                  });
              });

      },
      init() {
          this.reset();
          this.pageNo = 1;
          this.getList();
          this.getDictionaryItem();
      },
      getList() {
          this.loading = true
          let params = {
              softwareName: this.softwareName,
              orderNo: this.orderNo,
              state: this.activeName == 0 ? "" : this.activeName,
              createDate:
                  this.createDate == null
                      ? null
                      : this.createDate.join(" - "),
              current: this.pageNo,
              pageSize: this.pageSize,
              isBuy: true,
          };
          querySoftwareOrderDetailList(params).then((res) => {
              this.softwareOrderList = res.list;
              this.total = res.total;
              // console.log(this.modelOrderList);
              this.loading = false
          });
      },
      // 检索重置
      reset() {
          this.softwareName = "";
          this.orderNo = "";
          this.createDate = null;
          this.uuid = "";
      },
      handleSizeChange(val) {
          this.pageSize = val;
      },
    // 分页
    handleCurrentChange(val) {
      this.pageNo = val;
        this.getList();
    },
      // 点击打开评价弹出框
      toEvaluate(order) {
          this.order = order;
          console.log(order);
          this.evaluateForm = {
              descriptionPoint: 0,
              servicePoint: 0,
              transportPoint: 0,
              evaluationTagList: [],
              evaluationContent: "",
          };
          this.evaluateDialogVisible = true;
      },
      // 评价提交
      evaluateSubmit() {
          this.stepLoading = true;
          if (
              this.evaluateForm.descriptionPoint &&
              this.evaluateForm.servicePoint &&
              this.evaluateForm.transportPoint
          ) {
              this.evaluateForm.orderNo = this.order.orderNo;
              this.evaluateForm.orderUuid = this.order.uuid;
              this.evaluateForm.orderType = 'SOFTWARE';
              this.evaluateForm.evaluationType = 'NORMAL';
              // this.evaluateForm.sellerName = this.order.modelCreatorName;
              // this.evaluateForm.sellerUuid = this.order.modelCreatorUuid;
              this.evaluateForm.orderName = this.order.softwareName;
              this.evaluateForm.orderAmount = this.order.actualPayment;

              saveEvaluation(this.evaluateForm).then((response) => {
                  if (response.success) {
                      this.evaluateDialogVisible = false;
                      this.getList();
                      this.$message({
                          type: "success",
                          message: "评价成功",
                      });
                  } else {
                      this.$message({
                          type: "error",
                          message: response.message,
                      });
                  }
              });
          } else {
              this.$message.warning("请选择评价等级");
          }
          setTimeout(() => {
              this.stepLoading = false;
          }, 1000);
      },
      // 订单详情
      softwareOrderDetail(id) {
          this.$router.push({
              path: "/softwareOrderDetails",
              query: {
                  uuid: id,
              },
          });
      },
  },
};
</script>

<style scoped lang="less">
.softwareOrderList {
  padding: 94px 20px 20px;
  .orderListTabs {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 999;
    background: #fff;
    width: 100%;
    padding: 20px;
  }
  /deep/ .el-tabs__item {
    padding: 0 25px !important;
    text-align: center;

    &:hover {
      color: #3686d7;
    }

    &:after {
      content: "";
      position: absolute;
      right: 0;
      bottom: 12px;
      width: 1px;
      height: 15px;
      background-color: #e4e7ed;
      z-index: 1;
    }

    &:last-child:after {
      content: "";
      width: 0;
      height: 0;
    }
  }

  /deep/ .el-tabs__active-bar {
    height: 3px;
    background-color: #3686d7;
  }

  /deep/ .el-tabs__item.is-active {
    color: #3686d7;
  }

  /deep/ .el-tabs__nav-wrap::after {
    height: 1px;
  }

  .orderSearchBox {
    display: flex;
    flex-wrap: wrap;
.timeSearch{
                background-color:#f2f4f7;
                height: 35px;
                display: flex;
                align-items: center;
                margin-bottom: 22px;
                margin-right: 30px;
                border-radius: 8px;
                span{
                    font-size: 12px;
                    color: #c0c4cc!important;
                    font-weight: normal;
                    padding-left: 15px;
                    margin-right: 5px;
                }
                // /deep/ .el-range-input{
                //         background-color: #f2f4f7;
                //             &:hover, &:focus {
                //             background-color: #fff;
                //             // border: 1px solid #108EE9;
                //         }
                // }
                /deep/input::-webkit-input-placeholder {
                    color: #c0c4cc;
                    font-size: 12px;
                }
              /deep/.el-range-input:hover{
                  background-color: #fff!important;
              }
              /deep/ .el-date-editor .el-range-separator{
                  line-height: 25px;
                  color: #c0c4cc;
              }
             /deep/ .el-date-editor .el-range__close-icon{
                 line-height: 28px;
             }
              /deep/ .el-input__inner:hover  .el-range-input, /deep/ .el-input__inner:focus  .el-range-input{
                  background-color: white;
              }
                /deep/ .el-input__inner {
                width: 225px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;
                .el-range-input{
                    background-color:#f2f4f7 ;
                }

                &:hover, &:focus {
                    background-color: #fff;
                    border: 1px solid #108EE9;

                }
            }
            /deep/ .el-icon-date:before {
                    content: "\E78E";
                    display: none;
                }
                /deep/.el-input__icon{
                    // display: none;
                }
            }
    /deep/ .el-input {
      width: initial;
      margin-bottom: 22px;
      margin-right: 30px;
    }

    /deep/ .el-input__inner {
      width: 242px;
      height: 35px;
      min-height: 35px;
      font-size: 12px;
      color: #999999;
      background-color: #f2f4f7;
      border: 1px solid #f2f4f7;
      border-radius: 5px;

      &:hover,
      &:focus {
        background-color: #fff;
        border: 1px solid #108ee9;
      }
    }

    /deep/ .el-input__prefix {
      top: -3px;
    }

    /deep/ .el-input__suffix {
      top: 2px;
    }

    /deep/ .el-button {
      display: block;
      line-height: 35px;
      padding: 0;
      height: 35px;
    }

    .searchBtn {
      width: 82px;
      background: #3d7fff;
      border: none;
      border-radius: 15px;
      font-size: 14px;
      color: #ffffff;
        margin-bottom: 22px;
    }

    .resetBtn {
      color: #333333;
        margin-bottom: 22px;
    }
  }

  .orderListTable {
    .orderNomesaage {
        color: #888;
        text-align: center;
        padding: 15px 0;
    }
    .tableHeader {
      display: flex;
      width: 100%;
      height: 35px;
      line-height: 35px;
      background: #f3f7ff;
      border-radius: 5px;
      margin: 0 0 15px;
      li {
        text-align: center;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
      }
    }

    .tableBody {
      li {
        width: 100%;
        border: 1px solid #f2f2f2;
        border-radius: 10px;
        margin-bottom: 16px;

        .itemTop {
          width: 100%;
          height: 42px;
          background: #ebf3fb;
          line-height: 42px;
          font-size: 14px;
          color: #333;
          padding: 0 20px;
          display: flex;
          align-items: center;
          position: relative;

          div {
            margin-right: 30px;
          }

          .merchantInfo {
            display: flex;
            align-items: center;

            i {
              color: #3d7fff;
              font-size: 25px;
              cursor: pointer;
              padding-left: 5px;
              display: block;
            }

            img {
              display: block;
              padding-right: 5px;
            }
          }

          .complainBtn {
            color: #999;
            position: absolute;
            right: 20px;
          }
        }

        .itemBottom {
          display: flex;
          align-items: center;
          color: #333;
          font-size: 13px;
          .nameOne {
            display: flex;
            align-items: center;
            margin: 16px 0;
            margin-left: 20px;
            img {
              margin-right: 10px;
            }
          }
          .orderInfo {
            padding: 20px;
            display: flex;
            align-items: center;

            img {
              display: block;
              width: 147px;
              height: 83px;
              border-radius: 10px;
              margin-right: 30px;
            }

            .infoContent {
              margin-bottom: 16px;
              .infoName {
                font-size: 14px;
                color: #000000;
                padding-bottom: 10px;
              }

              .infoOther {
                font-size: 13px;
                color: #999999;
                padding-bottom: 8px;
              }
            }
          }

          .arguments {
            padding: 20px;
          }

          .argumentsName {
            padding-bottom: 8px;
          }
          .payment {
            h3 {
              font-size: 14px;
              font-weight: 700;
              margin: 0;
            }

            .title {
              font-size: 12px;
              color: #999999;
            }
          }
          .status {
            font-size: 14px;
          }
          .operationBtn {
            display: block;
            color: #0c75d3;
            text-align: center;
            width: 100%;
            margin: 0;
          }
          .operation {
            .operationBtnMoney {
              text-align: center;
              color: #0c75d3;
              padding: 6px 20px;
              border: 1px solid #0c75d3;
              border-radius: 6px;
              margin-left: 10px;
              margin-top: 12px;
              &:nth-last-of-type(1){
                margin-bottom: 12px;
              }
            }
          }

        }
      }
    }

    .name {
      flex: 1;
      text-align: center;
      img {
        width: 100px;
        // margin-top: 16px;
      }
    }
    .package {
      width: 100px;
      text-align: center;
    }
    .billing {
      width: 100px;
      text-align: center;
    }
    .price {
      width: 120px;
      text-align: center;
    }

    .num {
      width: 95px;
      text-align: center;
    }

    .payment {
      width: 100px;
      text-align: center;
    }

    .status {
      width: 200px;
      text-align: center;
    }

    .operation {
      width: 145px;
      text-align: center;
    }
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
.evaluateDialogBox {
    .evaluateItem {
        .name {
            font-size: 14px;
            color: #000;
            padding-bottom: 20px;
            font-weight: bold;
        }

        .content {
            padding-left: 20px;
            padding-bottom: 15px;
        }

        .rateItem {
            display: flex;
            align-items: center;
            padding-bottom: 15px;

            .name {
                padding: 0 20px 0 0;
                font-size: 13px;
                color: #333;
                min-width: 100px;
                font-weight: normal;
            }
        }

        .evaluateTag {
            display: flex;
            flex-wrap: wrap;

            /deep/ .el-checkbox-button {
                display: block;
                margin-right: 20px;
                margin-bottom: 15px;

            }

            /deep/ .el-checkbox-button__inner {
                border: 1px solid #DCDFE6 !important;
                border-radius: 4px;
                padding: 8px 15px;
                font-size: 13px;
                box-shadow: none;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/transaction/orderManagement/softwareOrderList.vue